import React from "react";

// Uses the official uploaded trust emblem
export const BuddhaLogo = ({ className = "h-11 w-11" }) => (
  <img
    src="/trust-logo.jpeg"
    alt="Lord Buddha Awareness And Development Foundation emblem"
    className={`${className} rounded-full object-cover ring-2 ring-amber-500/40 shadow-sm`}
    data-testid="nav-brand-logo"
  />
);

export default BuddhaLogo;
